var _toConsumableArray = require("/codebuild/output/src4110488206/src/2web2ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _objectSpread = require("/codebuild/output/src4110488206/src/2web2ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function (key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }
    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });
  return dest;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
var $bf39c630334f29ae$exports = {};
$parcel$export($bf39c630334f29ae$exports, "cumulativeSum", function () {
  return $bf39c630334f29ae$export$9e57366c37a5642e;
});
function $bf39c630334f29ae$export$9e57366c37a5642e(_ref) {
  var data1 = _ref.data,
    key = _ref.key;
  var results = data1.reduce(function (cumulativeDataSet, data) {
    var cumulativeData = _objectSpread({}, data);
    if (cumulativeDataSet.length > 0) cumulativeData[key] = data[key] + cumulativeDataSet[cumulativeDataSet.length - 1][key];
    cumulativeDataSet = [].concat(_toConsumableArray(cumulativeDataSet), [cumulativeData]);
    return cumulativeDataSet;
  }, []);
  return results;
}
var $efc110279246c456$exports = {};
$parcel$export($efc110279246c456$exports, "average", function () {
  return $efc110279246c456$export$cc6710ee5f037d57;
});
var $520fb4ec03cd9501$exports = {};
$parcel$export($520fb4ec03cd9501$exports, "safeDivide", function () {
  return $520fb4ec03cd9501$export$277aabc710d9a0ad;
});
function $520fb4ec03cd9501$export$277aabc710d9a0ad(numerator, denominator) {
  var value = numerator / denominator;
  return isFinite(value) ? value : 0;
}
function $efc110279246c456$export$cc6710ee5f037d57(item) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return $520fb4ec03cd9501$export$277aabc710d9a0ad(item[keys[0]], item[keys[1]]);
}
var $237709e97774e5de$exports = {};
$parcel$export($237709e97774e5de$exports, "rate", function () {
  return $237709e97774e5de$export$e8435ed7e8ba58fa;
});
var $8850a3df4d77aa80$exports = {};
$parcel$export($8850a3df4d77aa80$exports, "divide", function () {
  return $8850a3df4d77aa80$export$cd007d971a5a2143;
});
function $8850a3df4d77aa80$export$cd007d971a5a2143(numerator, denominator) {
  if (!denominator) return NaN; //Represents invalid value;
  return numerator / denominator;
}
function $237709e97774e5de$export$e8435ed7e8ba58fa(item) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return $8850a3df4d77aa80$export$cd007d971a5a2143(item[keys[0]], item[keys[1]]);
}
$parcel$exportWildcard(module.exports, $bf39c630334f29ae$exports);
$parcel$exportWildcard(module.exports, $efc110279246c456$exports);
$parcel$exportWildcard(module.exports, $237709e97774e5de$exports);
$parcel$exportWildcard(module.exports, $520fb4ec03cd9501$exports);
$parcel$exportWildcard(module.exports, $8850a3df4d77aa80$exports);